import { Layout } from '@shared/models/layout';
import { createContext } from 'react';

export const LayoutContext = createContext<Layout>('horizontal');
